import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

function SvgIcon(props) {
  const classes = classnames('icon', `icon--${props.name}`, {
    'icon--outlined': props.isOutlined,
    'icon--prism': props.isPrism
  });
  const midpoint = props.dimensions / 2;
  return (
    <svg
      className={classes}
      viewBox={`0 0 ${props.dimensions} ${props.dimensions}`}
      style={{ display: props.display, ...props.style }}
    >
      {props.pattern}
      <g transform={`rotate(${props.rotate} ${midpoint} ${midpoint})`}>
        {props.children}
      </g>
      <style jsx>{`
        .icon {
          width: 1em;
          height: 1em;
          fill: currentColor;
        }

        .icon--outlined {
          fill: transparent;
          stroke: currentColor;
          stroke-width: 5%;
        }

        .icon--prism {
          fill: url(#prism);
        }
      `}</style>
    </svg>
  );
}

SvgIcon.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
  rotate: PropTypes.number,
  display: PropTypes.string,
  isOutlined: PropTypes.bool,
  dimensions: PropTypes.number,
  style: PropTypes.shape({
    fill: PropTypes.string
  }),
  isPrism: PropTypes.bool,
  pattern: PropTypes.node
};

SvgIcon.defaultProps = {
  name: '',
  children: undefined,
  // rotate is based on degrees
  rotate: 0,
  display: 'block',
  isOutlined: false,
  // all SVG icons should be designed with a square bounding block
  dimensions: 128,
  style: {},
  isPrism: false,
  pattern: null
};

export default SvgIcon;
